import * as XLSX from 'xlsx';

export const handleFileRead = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      resolve(jsonData); // ✅ IMPORTANT
    };

    reader.onerror = reject;

    reader.readAsBinaryString(file);
  });
};